// utils/parseDateRangeSearch.ts
export type ParsedDateRange = {
  start: number;
  end: number;
};

export function getTodayDateRangeValue(): string {
  const today = new Date();
  const start = new Date(today.getFullYear(), today.getMonth(), today.getDate()).getTime();
  const end = new Date(today.getFullYear(), today.getMonth(), today.getDate(), 23, 59, 59, 999).getTime();

  return `${start},${end}`;
}

export function parseDateRangeSearch(createdDate: string | undefined, fallback?: ParsedDateRange): ParsedDateRange {
  const today = new Date();

  const defaultRange: ParsedDateRange = fallback ?? {
    start: new Date(today.getFullYear(), today.getMonth(), today.getDate()).getTime(),
    end: new Date(today.getFullYear(), today.getMonth(), today.getDate(), 23, 59, 59, 999).getTime(),
  };

  if (!createdDate) return defaultRange;

  const [start, end] = createdDate.split(',').map(Number);

  return {
    start: Number.isNaN(start) ? defaultRange.start : start,
    end: Number.isNaN(end) ? defaultRange.end : end,
  };
}
